module.exports = __webpack_public_path__ + "media/img/frontend_application/solution/virtualwedding-6fa21b35cefca5e5904870e4f2b9649a.jpg";